<template>
  <div id="staffTable">
    <div style="margin-bottom:20px;">
        <el-button size="mini" style="width:92px;" @click="addStaff">添加</el-button>
          <el-dropdown @command="exportHandle">
            <el-button type="primary" size="mini" style="width:92px;margin-left:10px;font-size:14px;">
              导出<i class="el-icon-arrow-down el-icon--right" style="margin-left:10px;"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command='person'>选中人员</el-dropdown-item>
              <el-dropdown-item command='all'>全部人员</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
         <el-dropdown @command="importHandle">
            <el-button  size="mini" style="width:92px;margin-left:10px;font-size:14px;background:#269d7b;color:#fff;">
              导入<i class="el-icon-arrow-down el-icon--right" style="margin-left:10px;"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command='import'>导入数据</el-dropdown-item>
              <el-dropdown-item command='downloadTemplate'>模板下载</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
            <el-input placeholder="搜索工号、姓名、证件号码" v-model="form.keyWord" size="mini" style="width:280px;">
                <el-button slot="append" icon="el-icon-search"  size="mini" @click="getList" style="background: #269d7b;color: #fff;"></el-button>
            </el-input>
        <el-select v-model="form.status" placeholder="请选择员工状态" @change="staffStatusHanlder" size="small" clearable class="selector_staff">
            <el-option
                v-for="item in staffStatusOptionList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
    </div>
    <public-table :table="tableData" @onHandlePaginationChange="handlePaginationChange" @selectChange="(list)=>selectList = list">
       <template v-for="(item ) in tableData.config" #[item.value]="{scope}" >
        <span v-if="scope.row" :key="item.value">
            <div   style="width:100%;min-height:27px;" v-show="!scope.row.isEdit || scope.row.id != currentId">
              <span v-if="item.value == 'cardType'">
                {{getCardType(scope.row[item.value])}}
              </span>
              <!-- && !['',null].includes(scope.row[item.value]) -->
              <span v-else-if="['disability','alone'].includes(item.value) ">
                <span>
                  {{scope.row[item.value]?'是':'否'}}
                </span>
              </span>
              <span v-else-if="item.value =='gender'">
                {{scope.row[item.value]==1?'男':'女'}}
              </span>
              <span v-else-if="item.value =='hireType'">
                {{getHireType(scope.row[item.value])}}
              </span>
              <span v-else-if="item.value =='currentJobInfo'">
                {{getCurrentJobInfo(scope.row[item.value])}}
              </span>
              <span v-else-if="item.value =='status'">
                {{scope.row[item.value]==1?'在职':'离职'}}
              </span>
              <span v-else-if="item.value == 'operation'">
                <el-button type="text" style="color:#269d7b;" @click="editTask(scope.row)" :disabled="scope.row.isLock == 1">编辑</el-button>
                <el-button type="text" style="color:#269d7b;" @click="editTask(scope.row,true)" >查看</el-button>
              </span>
              <span v-else> {{scope.row[item.value]}}</span>
             </div>
            <!-- <div v-show="scope.row.isEdit && scope.row.id == currentId">
              <div v-if="item.editType == 'select'" style="display:flex;align-items:center;">
                <el-select v-model="scope.row[item.value]" placeholder="请选择" :disabled="(item.value == 'gender' || item.value == 'nationality')&&scope.row.cardType == 1"   filterable :ref="`input_${item.value}_${scope.row.id}`" style="margin-right:5px;">
                  <el-option
                    v-for="item in item.selectList"
                    :key="item.id || item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div v-else-if="item.value == 'operation'">
                <el-button type="text" @click="cancel(scope.row,scope)" style="color:rgb(208, 214, 222);">取消</el-button>
                <el-button type="text" style="color:#269d7b;" @click="editRow(scope.row)">保存</el-button>
              </div>
              <el-input  v-else v-model="scope.row[item.value]" size="small" :ref="`input_${item.value}_${scope.row.id}`"  ></el-input>
            </div> -->
        </span>
      </template>
    </public-table>
    <!-- 导入 -->
     <ImportExcell ref="importExcell" @refresh="getList" :yearPeriod="yearPeriod"/>
    <!-- 添加员工 -->
    <AddStaff ref="addStaff" @refresh="getList"/>
  </div>
</template>

<script>
import {cardType,hireType,currentJobInfo,nationalityList} from '../index.js'
import AddStaff from './AddStaff.vue'
import ImportExcell from './ImportExcell.vue'
import publicTable from "@/components/publicTable";
import {getStaffList,saveStaff} from '@/api'
export default {
  components: {
    AddStaff,
    publicTable,
    ImportExcell
  },
  computed:{
    yearPeriod(){
        return JSON.parse(sessionStorage.getItem('accountInfo')).nowYearPeriod
    },
    cid(){
        return sessionStorage.getItem('cid')
    },
    token(){
         return sessionStorage.getItem('token')
    }
  },
  data() {
    return {
      oldRow:{},
      selectList:[],
      cardType,
      hireType,
      currentJobInfo,
      currentId:"",
      staffStatusOptionList:[
        {
          label: '在职',
          value: 1
        },
        {
          label: '离职',
          value: 2
        }
      ],
      form: {
        pageNo:1,
        pageSize:20,
        keyWord:"",
        status:"",
      },
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: true, // 是否显示多选
        hasOperation: false, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: false, // 是否显示合计行
        hasShowPagination: true, // 是否显示分页
        config: [
              { label: "工号", value: "workCode",   show:'template',editType:'input'},
              { label: "姓名", value: "name",   show:'template',editType:'input'},
              { label: "证件类型", value: "cardType",  show:'template',editType:'select',selectList:cardType},
              { label: "证件号码", value: "cardNo",show:'template',editType:'input'},
              { label: "性别", value: "gender",show:'template',editType:'select',selectList:[{ label: "男", value: 1 }, { label: "女", value: 2 }]},
              { label: "人员状态", value: "status",show:'template',editType:'select',selectList:[{ label: "在职", value: 1 }, { label: "离职", value: 2 }] },
              { label: "手机号", value: "phone", show:'template',editType:'input'},
              { label: "是否残疾", value: "disability", show:'template',editType:'select',selectList:[{label:'是',value:true},{label:'否',value:false}]},
              { label: "是否孤老", value: "alone", show:'template',editType:'select',selectList:[{label:'是',value:true},{label:'否',value:false}]},
              // { label: "是否烈属", value: "hero", show:'template',editType:'select',selectList:[{label:'是',value:true},{label:'否',value:false}]},
              { label: "任职受雇从业类型", value: "hireType",show:'template',selectList:hireType,editType:'select',},
              { label: "入职年度就业情形", value: "currentJobInfo",show:'template',editType:'select',selectList:currentJobInfo},
              { label: "国籍", value: "nationality",show:'template',editType:'select',selectList:nationalityList},
            //   { label: "经常居住地址籍", value: "address",show:'template',editType:'input'},
            //   { label: "联系地址", value: "contactAddress",show:'template',editType:'input'},
            //   { label: "户籍所在地", value: "homeAddress",show:'template',editType:'input'},
              { label: "备注", value: "newRemark", show:'template',editType:'input'},
              { label:"操作",value:"operation",show:'template'}
        ],
        data: [],
        page: {
          count: 0,
          pageNo: 1,
          pageSize: 20,
        },
        center: {
          textAlign: "center",
          padding: "6px 0",
        },
      },
    };
  },
  activated(){
    this.getList()
  },
  methods: {
    // 格式化出生日期，返回标准日期格式 YYYY-MM-DD
    formatDate(birthDateStr) {
      const year = birthDateStr.slice(0, 4);
      const month = birthDateStr.slice(4, 6);
      const day = birthDateStr.slice(6, 8);
      return `${year}-${month}-${day}`;
    },
    //根据身份证号识别性别
    getGenderByIdNumber(idNumber) {
        // 获取第17位数字（即性别标识位）
        const genderDigit = parseInt(idNumber.charAt(16));  // 第17位（从0开始）

        // 根据第17位的数字判断性别
        if (genderDigit % 2 === 0) {
            return 2;
        } else {
            return 1;
        }
    },
    cancel(row,scope){
      Object.assign(row,this.oldRow);
      console.log(row)
    },
    getHireType(value){
      const item = this.hireType.find(x=>x.value == value  || x.label == value)
      return item?item.label:""
    },
    getCurrentJobInfo(value){
      const item = this.currentJobInfo.find(x=>x.value == value  || x.label == value)
      return item?item.label:""
    },
    getCardType(value){
      const item = this.cardType.find(x=>x.value == value  || x.label == value)
      return item?item.label:""
    },
    editTask(row,isReadonly){
      // this.oldRow = JSON.parse(JSON.stringify(row))
      // this.currentId = row.id
      // row.isEdit = true
      this.$refs.addStaff.openTask(row,isReadonly)
    },
    async editRow(row,property){
      try{
        const cardNo = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dxX]$/; //身份证校验
        const pattern = /^1[3456789]\d{9}$/;  //手机号校验
        if(!cardNo.test(row.cardNo) && row.cardType == 1){
          this.$message.error('请输入正确的证件号码')
          return
        }else if(!pattern.test(row.phone)){
          this.$message.error('请输入正确的手机号码')
          return
        }
        if(row.cardType == 1){ //选择居民身份证 自动写入性别和出生日期
          row.gender = this.getGenderByIdNumber(row.cardNo)
          // 提取出生日期部分（第7-14位）
          const birthDateStr = row.cardNo.slice(6, 14);  // 18位身份证号，出生日期在第7至14位
          row.birthday = this.formatDate(birthDateStr)
        }
        let params = JSON.parse(JSON.stringify(row))
        params.entryDate = this.$formart(params.entryDate,'yyyy-MM-dd hh:mm:ss')
        params.createTime = this.$formart(params.createTime,'yyyy-MM-dd hh:mm:ss')
        params.dimissionDate = this.$formart(params.dimissionDate,'yyyy-MM-dd hh:mm:ss')
        params.salaryEndDate = this.$formart(params.salaryEndDate,'yyyy-MM-dd hh:mm:ss')
        params.salaryStartDate = this.$formart(params.salaryStartDate,'yyyy-MM-dd hh:mm:ss')
        params.updateTime = this.$formart(params.updateTime,'yyyy-MM-dd hh:mm:ss')
        const {data} = await saveStaff(params)
        if(data.code == 1){
          row.isEdit = false
          this.$message.success(data.msg)
          this.getList()
        }else {
          this.getList()
        }
      }finally{
      }

    },
    importHandle(command){
      if(command == 'import'){
        this.$refs.importExcell.openTask('员工表')
      }
      if(command == 'downloadTemplate'){
         window.location.href = `${this.$rootUrl}voucherChief/download?cid=${this.cid}&token=${this.token}&templateName=税局员工导入模板.xls`
      }
    },
    async getList(){
      try{
        this.tableData.loading = true
        const {data}  = await getStaffList(this.form)
        if(data.code == 1 && data.data && JSON.stringify(data.data) !== '{}'){
            this.tableData.data = data.data.list.map(x=>{
                this.$set(x,'isEdit',false)
                return x
            })
            this.tableData.page.count = Number(data.data.totalCount)
        }else{
          this.tableData.data = []
          this.tableData.page.count = 0
        }
      }catch(e){
      }finally{
        this.tableData.loading = false
      }
    },
    exportHandle(command){
      if(command == "person" && !this.selectList.length){
        this.$message.error('请选择至少一名人员')
        return
      }
      if(command == 'person'){
        const ids = this.selectList.map(x=>x.id).join(',')
        window.open(`${this.$rootUrl}newEmployee/exportEmployee?token=${this.token}&cid=${this.cid}&ids=${ids}`)
      }else if(command == 'all'){
        window.open(`${this.$rootUrl}newEmployee/exportEmployee?token=${this.token}&cid=${this.cid}`)
      }
      console.log(command)
    },

    addStaff(){
      this.$refs.addStaff.openTask()
    },
    handlePaginationChange(data) {
         this.form = Object.assign(this.form,data)
        this.getList()
    },
    staffStatusHanlder(){
        this.getList()
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-input-group__append {
    border: 0 !important;
   .el-button {
    height: 28px !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}

.selector_staff{
    /deep/.el-input--small .el-input__inner{
        height: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/salary/components/staffTable.vue